export default {
  AWDLogin: '/awdLogin',
  WorkQueue: '/applicationEntry/workQueue',
  ApplicationEntryWizard: '/applicationEntry/wizard',
  AppEntryLogin: '',
};
